import ClubImpersonalAccount from '../../../dto/ClubImpersonalAccount.js';
import Error from '../../../model/Error.js';
import axios from 'axios';

export default class ClubImpersonalAccountRepository {
    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/impersonal-accounts`)
                .then((response) => resolve(response.data.data.map((data) => ClubImpersonalAccount.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(clubId, clubImpersonalAccount) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/impersonal-accounts`, clubImpersonalAccount.serialize())
                .then((response) => resolve(response.headers['x-identifier']))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubImpersonalAccount) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/club-impersonal-accounts/${clubImpersonalAccount.id}`, clubImpersonalAccount.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(impersonalAccountId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-impersonal-accounts/${impersonalAccountId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
